import {
  BatchStatisticsCollectionConditionListItem,
  BatchStatisticsCollectionConditionListItemFromJSON
} from '@/api/models/batch/BatchStatisticsCollectionConditionListItem'

export interface BatchStatisticsCollectionSelectItemResult {
  items: BatchStatisticsCollectionConditionListItem
}

export function BatchStatisticsCollectionSelectItemResultFromJSON(
  json: any
): BatchStatisticsCollectionSelectItemResult {
  return {
    items: BatchStatisticsCollectionConditionListItemFromJSON(json)
  }
}
